import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';

/**
 * Payment Success Page
 * Shown after successful KaspiPay payment
 */
export default function PaymentSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home after 5 seconds
    const timer = setTimeout(() => {
      navigate('/my-courses');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className="absolute inset-0 bg-green-200 rounded-full animate-pulse" />
            <div className="relative bg-green-100 rounded-full p-4">
              <CheckCircle className="text-green-600" size={64} />
            </div>
          </div>
        </div>

        {/* Success Message */}
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Платёж успешен!</h1>
        <p className="text-gray-600 text-lg mb-2">
          Спасибо за вашу покупку
        </p>
        <p className="text-gray-500 text-sm mb-8">
          Курс добавлен в вашу библиотеку. Вы будете перенаправлены на страницу "Мои курсы"...
        </p>

        {/* Course Info */}
        <div className="bg-green-50 rounded-lg p-4 mb-8 border border-green-200">
          <p className="text-green-900 font-medium">
            ✓ Доступ предоставлен на неограниченное время
          </p>
          <p className="text-green-800 text-sm mt-2">
            Вы можете начать обучение прямо сейчас
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/my-courses')}
            className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition flex items-center justify-center gap-2"
          >
            Перейти к курсам
            <ArrowRight size={20} />
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-200 transition"
          >
            На главную
          </button>
        </div>

        {/* Receipt */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-left">
          <h3 className="font-semibold text-gray-900 mb-3">Детали платежа:</h3>
          <div className="space-y-2 text-sm text-gray-600">
            <div className="flex justify-between">
              <span>Платёжная система:</span>
              <span className="font-medium">KaspiPay</span>
            </div>
            <div className="flex justify-between">
              <span>Статус:</span>
              <span className="font-medium text-green-600">✓ Проверено</span>
            </div>
            <div className="flex justify-between">
              <span>Время:</span>
              <span className="font-medium">{new Date().toLocaleString('ru-RU')}</span>
            </div>
          </div>
        </div>

        {/* Help Text */}
        <p className="text-xs text-gray-500 mt-6">
          Если у вас есть вопросы, свяжитесь с поддержкой:
          <br />
          support@uaqyt.kz
        </p>
      </div>
    </div>
  );
}
